import {Component, Inject, OnInit} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {CityParams, UserSearchCity} from '@models/search';
import {AdService} from '@services/ad.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AlertService} from '@services/alert.service';

@Component({
    selector: 'app-save-city',
    templateUrl: './save-city.component.html',
    styleUrls: ['./save-city.component.scss']
})
export class SaveCityComponent implements OnInit {

    favoriteForm = new UntypedFormGroup({
        title: new UntypedFormControl(''),
    });
    currentSearch: UserSearchCity;
    searchParams: CityParams;
    loading = false;

    constructor(
        private adService: AdService,
        public dialogRef: MatDialogRef<SaveCityComponent>,
        private alertService: AlertService,
        @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    ngOnInit(): void {
        this.searchParams = this.data.searchParams;
        this.currentSearch = this.data.userSearch;

        this.favoriteForm = new UntypedFormGroup({
            title: new UntypedFormControl(''),
        });
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    onYesClick(): void {
        if (this.favoriteForm.valid && this.loading == false) {
            this.loading = true
            if (this.favoriteForm.get('title').value) {
                const newUserSearchCity: UserSearchCity = {
                    id: null,
                    title: this.favoriteForm.get('title').value,
                    search_city_params: this.searchParams,
                };

                this.adService.addUserSearchCity(newUserSearchCity).subscribe((us) => {
                    this.dialogRef.close({currentSearch: us});
                }, error => {
                    this.alertService.error('une erreur est survenue, veuillez réessayer ou nous contacter si le problème persiste.');
                    console.log(error);
                    this.loading = false;
                });
            } else {
                this.dialogRef.close(false);
            }
        }
    }
}
